import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ArdBaseComponent } from '@pages/components/genel/ard-base-component';

@Component({
    selector: 'ard-general-pdf-viewer-dialog',
    templateUrl: './general-pdf-viewer-dialog.component.html'
})

export class GeneralPdfViewerDialogComponent implements OnInit {

    pdfData: any;

    constructor(injector: Injector,
        public dialogRef: MatDialogRef<GeneralPdfViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit() {
        this.pdfData = this.binaryArrayeDonustur(this.data.pdfData);
    }

    kapat() {
        this.dialogRef.close({
        });
    }

    indir() {
        this.dosyaIndir(this.data.pdfData, this.data.title, 'application/pdf', '.pdf');
    }

    dosyaIndir(data: any, name: any, type: any, uzanti: any) {
        let array = this.binaryArrayeDonustur(data);
        let blob = new Blob([array], {
            type: type
        });
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            // IE11 and Edge
            (window.navigator as any).msSaveOrOpenBlob(blob, name + uzanti);
        } else {
            // Chrome, Safari, Firefox, Opera
            let url = URL.createObjectURL(blob);
            this.tarayiciIndirmeLinkiAc(url, name, uzanti);
            // Remove the link when done
            setTimeout(function () {
                window.URL.revokeObjectURL(url);
            }, 5000);
        }
    }

    binaryArrayeDonustur(dataURI: string) {
        var raw = window.atob(dataURI);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }

    private tarayiciIndirmeLinkiAc(url: string, name: string, uzanti: string) {
        let a = document.createElement('a');
        // Firefox requires the link to be in the body
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = url;
        a.download = name + uzanti;
        a.click();
        // Remove the link when done
        document.body.removeChild(a);
    }
    
}
